// Constantes fijas del visor de diseño del parque solar (solar-park).
// Extraídas de ViewerDesign.vue para separar los valores fijos de la presentación.

// Máximo de descargas de pictogramas EN PARALELO al cargar el parque. El navegador
// limita ~6 conexiones por dominio y el backend genera ~2MB por request, así que 6
// es el punto dulce (rápido sin saturar). El pool respeta este límite sea cual sea
// el número de pictogramas (5, 13, 50...).
export const LOAD_CONCURRENCY = 6;

// Opacidad del relleno de las estructuras CON estado en el parque solar. El
// visor compartido las pinta a 0.7 (translúcidas → color lavado); aquí
// las subimos para que el color de estado RESALTE más. Solo afecta a este visor.
// Subir a 1 para color 100% sólido; bajar hacia 0.7 para más transparencia.
export const SOLAR_FILL_OPACITY = 1;

// Cómo se pintan los elementos SIN estado en el parque. Flag en código (no env)
// para comparar al vuelo y quedarnos con el que mejor se vea:
//   'fill'    → relleno gris plomo macizo (opción B).
//   'outline' → contorno gris plomo, cuerpo vacío (opción A, paridad con el visor de pictograma).
export const NO_STATUS_RENDER_MODE = 'outline';

// Gris plomo, mismo tono que la línea gris del visor de pictograma (NO_STATUS_LINE_COLOR).
// En cuanto el elemento toma estado pasa a su color; así se ve lo que aún no tiene avance.
export const NO_STATUS_FILL_COLOR = '#e0e0e0';
export const NO_STATUS_OUTLINE_ALPHA = 0.8;  // alpha del contorno en modo 'outline'
export const NO_STATUS_OUTLINE_PX = 1;       // grosor objetivo del contorno en px (constante al zoom)
